import React, { useState } from 'react';
import {
  Container, Typography, TextField,
  Button, Paper, Alert, CircularProgress, Box
} from '@mui/material';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import axios from 'axios';
import './addEmailTemplate.css';
import { useNavigate } from 'react-router-dom'; 

const AddEmailTemplate = () => {
  const navigate = useNavigate(); 
  const [form, setForm] = useState({
    nom: '', sujet: '', type: '', contenu: '',
  });

  const [status, setStatus] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', text: '' });

    if (!form.nom || !form.sujet || !form.type || !form.contenu) {
      return setStatus({ type: 'error', text: 'Tous les champs sont obligatoires.' });
    }

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates`, form);
      setStatus({ type: 'success', text: 'Modèle ajouté avec succès.' });
      setForm({ nom: '', sujet: '', type: '', contenu: '' });
    } catch (err) {
      setStatus({ type: 'error', text: err.response?.data?.message || 'Erreur lors de l’ajout.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Container maxWidth="md">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5">
            Ajouter un modèle d'e-mail
          </Typography>
          <Button variant="outlined" onClick={() => navigate('/admin/email-templates')}>
            Voir les modèles
          </Button>
        </Box>

        <Paper elevation={3} className="add-email-template">
          {status.text && (
            <Alert severity={status.type}>{status.text}</Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              label="Nom du modèle *"
              name="nom"
              value={form.nom}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Sujet *"
              name="sujet"
              value={form.sujet}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Type *"
              name="type"
              value={form.type}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Contenu de l'e-mail *"
              name="contenu"
              value={form.contenu}
              onChange={handleChange}
              fullWidth
              multiline
              rows={8}
              margin="normal"
              required
            />
            <div className="email-template-submit">
              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={20} color="inherit" /> : 'Ajouter'}
              </Button>
            </div>
          </form>
        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default AddEmailTemplate;
